export default __webpack_public_path__ + "static/6.5 - 1-f889abb344ce9ad973a8836b5f1e9294.png";